import { DispositionType } from '../types';

export const mapDispositionTypeToLabel: Record<DispositionType, string> = {
  ip: 'telemed.plan.disposition.types.ip',
  'ip-lab': 'telemed.plan.disposition.types.ip-lab',
  pcp: 'telemed.plan.disposition.types.pcp',
  ed: 'telemed.plan.disposition.types.ed',
  'ip-oth': 'telemed.plan.disposition.types.ip-oth',
  'pcp-no-type': 'telemed.plan.disposition.types.pcp-no-type',
  another: 'telemed.plan.disposition.types.another',
  specialty: 'telemed.plan.disposition.types.specialty',
};

export const dispositionCheckboxOptions = [
  {
    label: 'Dentistry',
    name: 'dentistry',
  },
  {
    label: 'ENT',
    name: 'ent',
  },
  {
    label: 'Ophthalmology',
    name: 'ophthalmology',
  },
  {
    label: 'Orthopedics',
    name: 'orthopedics',
  },
  {
    label: 'Other',
    name: 'other',
  },
  // {
  //   label: 'Lurie CT',
  //   name: 'lurie-ct',
  // },
] as const;
